
              import "_sentry-debug-id-injection-stub";
              import * as OriginalModule from "./src/index.tsx";
              export default OriginalModule.default;
              export * from "./src/index.tsx";